/**
* A service that allows getting of product schemas
*/
export class ProductSchemaService {
  private schemas = [];
  private resource: InterACT.Interfaces.IResource<InterACT.Interfaces.ProductSchemas.ProductSchemaResponse>;

  constructor(private $resource: ng.resource.IResourceService) {
    this.resource = $resource(
      'api/product-schemas/:productSchemaId',
      undefined,
      { edit: { method: 'PATCH' }, update: { method: 'PUT' } }
    );
  }

  /**
   * Gets product schema for input id
   *
   * @param productSchemaId The id to search for
   *
   * @returns a promise that resolves with a Product schema response
   */
  public getSchema(productSchemaId: string) {
    return this.resource.get({ productSchemaId: productSchemaId }).$promise.then((resource) => {
      return resource['productSchema'];
    });
  }

  /**
   * Gets the full list of product schemas
   *
   * @returns a promise that resolves with a Product schema response
   */
  public getList() {
    return this.resource.get().$promise.then((resource) => {
      return this.schemas = resource['productSchemas'];
    });
  }

  /**
   * Gets the schemas list
   *
   * @returns the list of schemas
   */
  public list() {
    return this.schemas;
  }

  /**
   * Gets the schema ids list
   *
   * @returns the list of ids
   */
  public listIds() {
    return _.map(this.schemas, 'id');
  }

  /**
   * Gets the schema names list
   *
   * @returns the list of names
   */
  public listNames() {
    return _.map(this.schemas, (schema) => {
      return _.pick(schema, 'id', 'name');
    });
  }
}
